import { render, staticRenderFns } from "./DropdownItem.vue?vue&type=template&id=e8663ee0&scoped=true"
import script from "./DropdownItem.vue?vue&type=script&lang=js"
export * from "./DropdownItem.vue?vue&type=script&lang=js"
import style0 from "./DropdownItem.vue?vue&type=style&index=0&id=e8663ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8663ee0",
  null
  
)

export default component.exports